<template>
  <div class="range-slider js">
    <input
      v-model="newValue"
      type="range"
      :min="min"
      :max="max"
      :step="step"
      class="range-slider__range"
      :style="{ '--min': min, '--max': max, '--val': newValue }"
    />
  </div>
</template>

<script>
export default {
  name: 'AppRangeSlider',
  props: {
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 50000,
    },
    step: {
      type: Number,
      default: 10,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    newValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
};
</script>
